import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosInstance';
import { useForm } from 'react-hook-form';
import { Button, TextField, Paper, Typography, Stack, } from '@mui/material';
import { ChevronRight, ChevronLeft, Send, } from '@mui/icons-material';

const ContactInputPage = () => {
  const formRef = useRef(null);
  const [error, setError] = useState('');
  const { register, handleSubmit, formState: { errors } } = useForm({});
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(true);

  const onSubmit = async (data) => {
    if (isEditMode) {
      setIsEditMode(false);

      requestAnimationFrame(() => {
        formRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      });

      return;
    }
    try {
      const res = await axiosInstance.post('/contact', data);
      if (res.status === 200) {
        navigate('/contact/complete');
      }
    } catch (err) {
      console.error(err);
      setError('送信に失敗しました。しばらくしてから再度お試しください。');
    }
  };
  return (
    <>
      <Typography component="h1" variant="h1">お問合わせ</Typography>
      <Typography>下記の入力項目を記載の上、内容を送信ください。※営業目的の利用はご遠慮ください。</Typography>

      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} ref={formRef}>
        <Paper variant='section'>

          <Stack spacing={2}>
            <TextField
              label='お名前*'
              size="medium"
              {...register("name", { required: "お名前は必須です", maxLength: { value: 50, message: '50文字以内で入力してください' }, })}
              error={!!errors.name}
              helperText={errors.name?.message}
              disabled={!isEditMode}
              inputProps={{ maxLength: 50 }}
              multiline
            />
            <TextField
              label='メールアドレス*'
              size="medium"
              type="email"
              {...register("email", {
                required: "メールは必須です",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "有効なメールアドレスを入力してください",
                },
                maxLength: { value: 255, message: '255文字以内で入力してください' },
              })}
              error={!!errors.email}
              helperText={errors.email?.message}
              disabled={!isEditMode}
              inputProps={{ maxLength: 255 }}
              multiline
            />
            <TextField
              label='お問合わせ内容*'
              size="medium"
              multiline
              minRows={8}
              {...register("message", { required: "内容は必須です", maxLength: { value: 2000, message: '2000文字以内で入力してください' }, })}
              error={!!errors.message}
              helperText={errors.message?.message}
              disabled={!isEditMode}
              inputProps={{ maxLength: 2000 }}
            />
            {error && (
              <Typography color="error" sx={{ mt: 1 }}>
                {error}
              </Typography>
            )}
          </Stack>

          <div className="button-row">
            <Button
              type={isEditMode ? 'submit' : 'button'}
              variant={isEditMode ? 'contained' : 'outlined'}
              startIcon={!isEditMode ? <ChevronLeft /> : null}
              endIcon={isEditMode ? <ChevronRight /> : null}
              onClick={() => {
                if (!isEditMode) {
                  setIsEditMode(true);
                }
              }}
            >
              {isEditMode ? '入力内容を確認する' : '戻る'}
            </Button>

            {!isEditMode && (
              <Button
                type="submit"
                variant="contained"
                endIcon={<Send />}
              >
                この内容で送信
              </Button>
            )}
          </div>
        </Paper>
      </form>
    </>
  );
};

export default ContactInputPage;
